import PropTypes from 'prop-types';
import { asTimeISO } from 'utils/date-formatter';
import { appConstants } from 'utils/global-constants';
import { ReactComponent as IconLock } from 'assets/icons/svgs/icon-lock.svg';
import { ReactComponent as IconInfo1 } from 'assets/icons/svgs/icon-info1.svg';
import { ReactComponent as IconAccessibility } from 'assets/icons/svgs/icon-accessibility.svg';

import './SelectTimeButton.scss';

export const SelectTimeButton = (props) => {
  const {
    PerformanceDateTime,
    IsoPerformanceDateTime,
    PerformanceLabel,
    Available,
    FullPriceRange,
    PerformanceId,
    isSelected,
    performanceIdSelectedHandler,
  } = props;
  const performanceTime = asTimeISO(IsoPerformanceDateTime || PerformanceDateTime);

  /*
   * Default Button
   */
  const defaultButton = (
    <button
      type="button"
      data-testid="select-time-item"
      onClick={() => performanceIdSelectedHandler(PerformanceId)}
      className={`select-time__button text-bar ${isSelected ? 'selected' : ''} ${
        !Available ? 'disabled' : ''
      }`}
    >
      <div className="pull-left event-time">{performanceTime}</div>
      <div className="pull-right">
        {PerformanceLabel?.Label && (
          <div className="event-price-range">{PerformanceLabel.Label}</div>
        )}
        {FullPriceRange && <div className="event-price-range">{FullPriceRange}</div>}
      </div>
    </button>
  );

  const getButtonType = () => {
    /*
     * Selling Fast Button
     */
    if (PerformanceLabel.MessageID === appConstants.LabelType.SellingFast) {
      return (
        <button
          type="button"
          data-testid="select-time-item"
          onClick={() => performanceIdSelectedHandler(PerformanceId)}
          className={`select-time__button text-bar ${isSelected ? 'selected' : ''} ${
            !Available ? 'disabled' : ''
          }`}
        >
          <div className="pull-left event-time">{performanceTime}</div>
          <div className="pull-right">
            <div className="event-info  text-danger">Selling fast</div>
            {FullPriceRange && <div className="event-price-range">{FullPriceRange}</div>}
          </div>
        </button>
      );
    }

    /*
     * Allocation Exhausted Button
     */
    if (PerformanceLabel.MessageID === appConstants.LabelType.AllocationExhausted) {
      return (
        <button
          type="button"
          data-testid="select-time-item"
          className={`select-time__button text-bar ${isSelected ? 'selected' : ''} ${
            !Available ? 'disabled' : ''
          }`}
        >
          <div className="pull-left event-time">{performanceTime}</div>
          <div className="pull-right">
            <div className="event-info">Allocation exhausted</div>
            {FullPriceRange && <div className="event-price-range">{FullPriceRange}</div>}
          </div>
        </button>
      );
    }

    /*
     * Performance Unavailable Button
     */
    if (PerformanceLabel.MessageID === appConstants.LabelType.PerformanceUnavailable) {
      return (
        <>
          <button
            type="button"
            data-testid="select-time-item"
            className="select-time__button text-bar disabled single"
          >
            <div className="pull-left event-time">{performanceTime}</div>
            <div className="pull-right">
              <div className="event-info text-info">
                <IconLock className="icon" />
                Performance Unavailable
              </div>
              {FullPriceRange && <div className="event-price-range">{FullPriceRange}</div>}
            </div>
          </button>
          <div className="callout-container callout-info presale-buy-info">
            <div className="mod-icon-left">
              <IconInfo1 className="icon" />
              <p className="small">
                This session is currently not available. Please select another one. If you have a
                promo code to access this performance session, please enter in the
                <strong>'Promo code'</strong> field above.
              </p>
            </div>
          </div>
        </>
      );
    }

    /*
     * Members Only Button
     */
    if (PerformanceLabel.MessageID === appConstants.LabelType.MembersOnly) {
      return (
        <button
          type="button"
          data-testid="select-time-item"
          className={`select-time__button text-bar ${isSelected ? 'selected' : ''} ${
            !Available ? 'disabled' : ''
          }`}
        >
          <div className="pull-left event-time">{performanceTime}</div>
          <div className="pull-right">
            <div className="event-info">
              <IconLock className="icon" />
              Members only
            </div>
            {FullPriceRange && <div className="event-price-range">{FullPriceRange}</div>}
          </div>
        </button>
      );
    }

    /*
     * Accessible Button
     */

    if (PerformanceLabel.MessageID === appConstants.LabelType.Accessible) {
      return (
        <button
          type="button"
          data-testid="select-time-item"
          onClick={() => performanceIdSelectedHandler(PerformanceId)}
          className={`select-time__button text-bar ${isSelected ? 'selected' : ''} ${
            !Available ? 'disabled' : ''
          }`}
        >
          <div className="pull-left event-time">{performanceTime}</div>
          <div className="pull-right">
            <div className="event-info">
              <IconAccessibility className="icon" />
              Accessible
            </div>
            {FullPriceRange && <div className="event-price-range">{FullPriceRange}</div>}
          </div>
        </button>
      );
    }

    return defaultButton;
  };

  const showDefaultButton =
    !PerformanceLabel ||
    !PerformanceLabel.MessageID ||
    PerformanceLabel.MessageID === appConstants.LabelType.Default;

  return showDefaultButton ? defaultButton : getButtonType();
};

SelectTimeButton.propTypes = {
  PerformanceDateTime: PropTypes.string,
  IsoPerformanceDateTime: PropTypes.string,
  PerformanceLabel: PropTypes.object,
  Available: PropTypes.bool,
  FullPriceRange: PropTypes.string,
  PerformanceId: PropTypes.number,
  isSelected: PropTypes.bool,
  performanceIdSelectedHandler: PropTypes.func,
};
